import { getSearchParams } from '@vimeo/viewer-showcase-ui/utils/helper';

import { useGetInfiniteVideos } from './use-get-playlist-videos';
import { findWithAdjacent } from '../utils/helper';

export const useSelectedId = () => {
  const { clips } = useGetInfiniteVideos();

  const searchParams = getSearchParams();
  const clipId = searchParams.get('video');
  const eventId = searchParams.get('event');

  const {
    selected: selectedClipData,
    prev: prevClipData,
    next: nextClipData,
  } = findWithAdjacent(clips || [], (clip) => clip.clipId === clipId);

  return {
    selectedId: clipId,
    selectedClipData,
    prevClipData,
    nextClipData,
    isLiveEvent: Boolean(clipId) && Boolean(eventId), // not all live clips are live event (back support One Time Event); Only show when Live Event's live clips are non-archived (event id exists in the url)
    isVideoClip: Boolean(clipId) && !Boolean(eventId),
  };
};
